import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Stack, AppBar, Toolbar, IconButton } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// hooks
import useOffSetTop from '../../../hooks/useOffSetTop';
import useResponsive from '../../../hooks/useResponsive';
// config
import { HEADER } from '../../../config-global';
// components
import Iconify from '../../../components/iconify';
//
// import JJMISearchbar from './JJMISearchbar';
import NSMNotificationPopover from './NSMNotificationPopover';
import { PATH_AUTH } from '../../../routes/paths';
import { handleError } from '../../../auth/utils';
import UserMasterService from '../../../services/userMaster.service';
import AppCache from '../../../services/appcache';
// ------------------------------------------------------------------------------------------------------

NSMHeader.propTypes = {
    openNav: PropTypes.bool,
    onOpenNav: PropTypes.func,
    navWidth: PropTypes.number,
};
// ------------------------------------------------------------------------------------------------------

export default function NSMHeader({ openNav, onOpenNav, navWidth }) {

    const navigate = useNavigate();
    const theme = useTheme();
    const isDesktop = useResponsive('up', 'lg');
    const isOffset = useOffSetTop(HEADER.H_DASHBOARD_DESKTOP);

    const handleClick = () => {
        AppCache.ClearStorage();

        UserMasterService.LogOut()
            .then((response) => {
                if (response.status === 200) {
                    navigate(PATH_AUTH.login);
                }
                else {
                    // TODO: Handle error and show it to user
                    console.log("error")
                    navigate(PATH_AUTH.login);
                }
            })
            .catch(_error => {
                //  handleError(_error, navigate, "", "");
                console.log("error", _error)
                navigate(PATH_AUTH.login);
            });
    };

    const renderContent = (
        <>
            {!openNav && (
                <IconButton onClick={onOpenNav} sx={{ mr: 1, color: 'text.primary' }}>
                    <Iconify icon="eva:menu-2-fill" />
                </IconButton>
            )}

            <img src='/logo/J&J MedTech Logo.png' alt='' draggable={false} className='JnJMedTechLogo' />

            <Stack
                flexGrow={1}
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                spacing={{ xs: 0.5, sm: 1 }}
            >
                {/*    <JJMISearchbar />    */}

                <NSMNotificationPopover />
                <IconButton sx={{
                    width: 40, height: 40, color: '#B50000',
                    ":hover": {
                        cursor: "pointer",
                        color: "#FB0000",
                    },
                }}
                    onClick={(event) => {
                        handleClick(event);
                    }}>
                    <Iconify icon="mdi:shutdown" />
                </IconButton>
            </Stack>
        </>
    );

    return (
        <AppBar
            sx={{
                boxShadow: 'none',
                height: HEADER.H_MOBILE,
                zIndex: theme.zIndex.appBar + 1,
                ...bgBlur({
                    color: theme.palette.background.default,
                    backgroundColor: theme.palette.background.paper,
                }),
                transition: theme.transitions.create(['height'], {
                    duration: theme.transitions.duration.shorter,
                }),
                ...(isDesktop && {
                    width: `calc(100% - ${navWidth + 1}px)`,
                    height: HEADER.H_DASHBOARD_DESKTOP,
                    backgroundColor: theme.palette.background.paper,
                    ...(isOffset && {
                        //  height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
                    }),
                }),
            }}
        >
            <Toolbar
                sx={{
                    height: 1,
                    px: { lg: 5 },
                }}
            >
                {renderContent}
            </Toolbar>
        </AppBar>
    );
}
